//
import mitt, { Emitter } from 'mitt';

export class PubSub
{
    private backbone : Emitter<PubSub.Event>;

    constructor()
    {
        this.backbone = mitt<PubSub.Event>();
    }

    public makeEmpty() : void
    {
        this.backbone.all.clear();
    }

    public addSubscriber( type : string, callback : PubSub.Callback ) : void
    {
        this.backbone.on( type, callback );
    }

    public removeSubscriber( type : string, callback : PubSub.Callback ) : void
    {
        this.backbone.off( type, callback );
    }

    public refreshSubscriber( type : string, callback : PubSub.Callback ) : void
    {
        this.removeSubscriber( type, callback );
        this.addSubscriber( type, callback );
    }

    public publish( type : string, data : PubSub.Event ) : void
    {
        this.backbone.emit( type, data );
    }

    public diagnose() : void
    {
        for (const [event, handlers] of this.backbone.all)
        {
            console.log(`Event: ${String(event)}, Subscribers: ${handlers.length}`);
        }
    }

}

export namespace PubSub
{
    export type Event = any;
    export type Callback = (event: PubSub.Event) => void;
}

export default PubSub;

// eof